module.exports = __webpack_public_path__ + "img/silly.460b23d5.gif";